/** @format */

import {
    blackColor,
    dangerBoxShadow,
    dangerColor,
    defaultFont,
    grayColor,
    hexToRgb,
    infoBoxShadow,
    infoColor,
    primaryBoxShadow,
    primaryColor,
    roseBoxShadow,
    roseColor,
    successBoxShadow,
    successColor,
    warningBoxShadow,
    warningColor,
    whiteColor,
} from '../../../../jss/material-dashboard-pro-react';
import COLORS from '../../colors';

const adminNavbarStyle = {
    popperClose: {
        pointerEvents: 'none',
        display: 'none !important',
    },
    manager: {
        '& > div > button:first-child > span:first-child, & > div > a:first-child > span:first-child': {
            width: '100%',
        },
    },
    innerManager: {
        '& > div > button,& > div > a': {
            margin: '0px !important',
            color: 'inherit !important',
            padding: '10px 20px !important',
            '& > span:first-child': {
                width: '100%',
                justifyContent: 'flex-start',
            },
        },
    },
    target: {
        '& > button:first-child > span:first-child, & > a:first-child > span:first-child': {
            display: 'inline-block',
        },
        '& $caret': {
            marginLeft: '0px',
        },
    },
    dropdown: {
        border: '0',
        top: '100%',
        zIndex: '1000',
        minWidth: '160px',
        margin: '2px 0 0',
        textAlign: 'left',
        listStyle: 'none',
        padding: 0,
        backgroundColor: COLORS.MAIN.LIGHT,
        opacity: 1 + ' !important',
    },
    menuList: {
        padding: '0',
    },
    dropdownItem: {
        padding: '10px 20px',
        position: 'relative',
        transition: 'all 150ms linear',
        display: 'block',
        clear: 'both',
        height: '100%',
        color: COLORS.MAIN.DARK,
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: COLORS.MAIN.LIGHT,
            opacity: 1,
        },
    },
    primaryHover: {
        '&:hover': {
            opacity: 1,
            backgroundColor: COLORS.MAIN.PRIMARY,
            color: COLORS.MAIN.LIGHT,
        },
    },
    infoHover: {
        '&:hover': {
            backgroundColor: infoColor[0],
            color: whiteColor,
            ...infoBoxShadow,
        },
    },
    successHover: {
        '&:hover': {
            backgroundColor: successColor[0],
            color: whiteColor,
            ...successBoxShadow,
        },
    },
    warningHover: {
        '&:hover': {
            backgroundColor: warningColor[0],
            color: whiteColor,
            ...warningBoxShadow,
        },
    },
    dangerHover: {
        '&:hover': {
            backgroundColor: dangerColor[0],
            color: whiteColor,
            ...dangerBoxShadow,
        },
    },
    roseHover: {
        '&:hover': {
            backgroundColor: roseColor[0],
            color: whiteColor,
            ...roseBoxShadow,
        },
    },
    dropdownItemRTL: {
        textAlign: 'right',
    },
    dropdownDividerItem: {
        margin: '5px 0',
        height: '1px',
        overflow: 'hidden',
    },
    buttonIcon: {
        width: '20px',
        height: '20px',
    },
    caret: {
        transition: 'all 150ms ease-in',
        display: 'inline-block',
        width: '0',
        height: '0',
        marginLeft: '4px',
        verticalAlign: 'middle',
        borderTop: '4px solid',
        borderRight: '4px solid transparent',
        borderLeft: '4px solid transparent',
    },
    caretActive: {
        transform: 'rotate(180deg)',
    },
    caretDropup: {
        transform: 'rotate(180deg)',
    },
    caretRTL: {
        marginRight: '4px',
    },
    dropdownHeader: {
        display: 'block',
        padding: '0.1875rem 1.25rem',
        fontSize: '0.75rem',
        lineHeight: '1.428571',
        color: grayColor[1],
        whiteSpace: 'nowrap',
        fontWeight: 'inherit',
        marginTop: '10px',
        '&:hover,&:focus': {
            cursor: 'auto',
        },
    },
    noLiPadding: {
        padding: '0',
    },
};

export default adminNavbarStyle;
